<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放页面
-->
<template>
	<!--车辆监控页面_右侧tab面板之车辆报警开始-->
	<div id="alarm-right-sidebar" :class="activeClass">
		<div class="tab-row" style="height:100%">
			<div class="alarm_remind ">
				<!-- 切换标签打开关闭的状态 移动open的位置即可 移到那一栏 当栏展开 其他栏合并 -->
				<div v-show="alarmrightsidebar1" class="vehicle_alarm open">
					<vehicle-alarm-emg
						v-on:openAlarm="openAlarm"
						v-on:openTip="opentip"
						></vehicle-alarm-emg>
				</div>
				<div v-show="alarmrightsidebar2" class="vehicle_alarm open">
					<vehicle-alarm-ord
						v-on:openAlarm="openAlarm"
						v-on:openTip="opentip"
						></vehicle-alarm-ord>	
				</div>
				<div v-show="alarmrightsidebar3" class="vehicle_alarm open">
					<vehicle-alarm-gen
						v-on:openAlarm="openAlarm"
						v-on:openTip="opentip"
						></vehicle-alarm-gen>
				</div>
			</div>
		</div>
		
	</div>
	<!--车辆监控页面_右侧tab面板之车辆报警结束-->
</template>
<script>
	import VehicleAlarmEmg from 'components/modules/layouts/VehicleAlarmEmg'
	import VehicleAlarmGen from 'components/modules/layouts/VehicleAlarmGen'
	import VehicleAlarmOrd from 'components/modules/layouts/VehicleAlarmOrd'
	export default {
		name: 'AlarmRightSidebar',
		components:{
			VehicleAlarmEmg,
			VehicleAlarmGen,
			VehicleAlarmOrd
		},
		computed: {
			activeClass() {
		  	 	return {
		       		'sidebar-open': this.$store.state.global.alarmrightsidebar1 || 
		       						this.$store.state.global.alarmrightsidebar2 || 
		       						this.$store.state.global.alarmrightsidebar3
				   }
	        },
	        alarmrightsidebar1() {
	        	return this.$store.state.global.alarmrightsidebar1
	        },
	        alarmrightsidebar2() {
	        	return this.$store.state.global.alarmrightsidebar2
	        },
	        alarmrightsidebar3() {
	        	return this.$store.state.global.alarmrightsidebar3
	        }
		},
		methods:{
			openAlarm(obj){
				this.$emit('openAlarm',obj)
			},
			opentip(tip){
				this.$emit('opentip',tip)
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// AlarmRightSidebar.vue?edbc5adc